<template>
  <div class="wrap">
    <Swiper class="swiper_c" />
    <div class="content">
      <!-- <jobSearch :onsearch="search" /> -->
      <jobCategory :onsearch="search" />
      <jobList ref="jobList" />
      <jobWelfare />
    </div>
  </div>
</template>

<script>
import ModuleTitle from "@/components/ModuleTitle";

import Swiper from "./Swiper";
import jobSearch from "./jobSearch";
import jobCategory from "./jobCategory";
import jobList from "./jobList";
import jobWelfare from "./jobWelfare";

import { getBannerList } from "@/apis/banner";

export default {
  beforeRouteEnter(to, from, next) {
    console.log("beforeRouteEnter");
    next((vm) => {
      console.log("vm.jobs", vm.jobs);
    });
  },
  name: "job",
  components: {
    ModuleTitle,
    jobSearch,
    jobCategory,
    jobList,
    jobWelfare,
    Swiper,
  },
  data() {
    return {
      bannerImage: "",
      bannerTitle: "你好!互联网新势力!",
      bannerDesc: "THE EASIEST WAY TO GET YOUR NEW JOB",
      bannerList: [],
      jobs: [],
      name: "",
      classId: "",
    };
  },
  created() {
    let me = this;
    // this._getProductList({ page: 1, size: 10 })
    me.loadBannerList(
      {
        position: "招聘页",
        status: "0",
        pageSize: 10,
        pageNum: 1,
      },
      function () {
        if (!me.bannerList) return;
        var lst = me.bannerList;
        if (!lst[0]) return;
        me.bannerImage = me.baseConfig.baseUrl + lst[0].imageUrl;
      }
    );
  },
  methods: {
    search(keyword, title) {
      this.name = keyword;
      if (title) this.classId = title;
      this.$refs.jobList.loadJobList({
        name: this.name,
        classId: this.classId,
      });
    },
    loadBannerList(params, onInit) {
      let me = this;
      getBannerList(params).then((rst) => {
        me.bannerList = rst.rows;
        onInit && onInit();
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.swiper_c {
  width: 100%;
  height: 500px;
}
@media screen and (min-width: 768px) and (max-width: 1920px) {
  .wrap {
    overflow: hidden;
  }

  .banner_wrap {
    position: relative;
    width: 100%;
    height: 500px;
    background-color: rgba(0, 0, 0, 0.35);
  }

  .loading {
    position: absolute;
    width: 100%;
    height: calc(100vh - 0.8rem);
    background-color: rgba(0, 0, 0, 0.35);
    z-index: 1;
  }

  .banner {
    background-size: cover;
    height: 100%;
    width: calc(100% + 100px);
    left: -50px;

    &:before {
      width: 100%;
      height: 100%;
      content: "";
      background: fade(#000, 35);
      display: block;
    }
  }

  .banner_span_wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: 0 auto;
    z-index: 2;
  }

  .banner_span1,
  .banner_span2 {
    color: #fff;
  }

  .banner_span1 {
    font-size: 0.56rem;
    line-height: 0.7rem;
  }

  .banner_span2 {
    font-size: 0.16rem;
    line-height: 0.4rem;
  }

  .content {
    // padding: 0.7rem 1rem;
  }
}

@media screen and (max-width: 768px) {
  .wrap {
    overflow: hidden;
  }

  .banner_wrap {
    position: relative;
    width: 100%;
    height: 7rem;
    background-color: rgba(0, 0, 0, 0.35);
  }

  .loading {
    position: absolute;
    width: 100%;
    height: 7rem;
    background-color: rgba(0, 0, 0, 0.35);
    z-index: 1;
  }

  .banner {
    background: url("https://zos.alipayobjects.com/rmsportal/bXNBIyzSLHaycUGDzwLG.jpg")
      center;
    background-size: cover;
    height: 100%;
    width: calc(100% + 0.5rem);
    left: -0.25rem;

    &:before {
      width: 100%;
      height: 100%;
      content: "";
      background: fade(#000, 35);
      display: block;
    }
  }

  .banner_span_wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: 0 auto;
    z-index: 2;
  }

  .banner_span1,
  .banner_span2 {
    color: #fff;
  }

  .banner_span1 {
    font-size: 0.76rem;
    line-height: 0.9rem;
  }

  .banner_span2 {
    font-size: 0.36rem;
    line-height: 0.6rem;
  }

  .content {
    // padding: 0.7rem 1rem;
  }
}
</style>